import React, { useEffect, useState } from "react";

// Ant Design
import { Tabs, Row, Col, Typography, Card } from "antd";

import {FileManagementDashboard} from "./FileManagementDashboard.jsx";
import {FileAnalyticsCharts} from "./FileAnalyticsCharts.jsx";

// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen, faChartColumn, faEye, faEyeSlash, faFile } from "@fortawesome/free-solid-svg-icons";

// Servicio real
import { getInformeParticipante } from "../../services/InformeActas/InformeParticipante.js";

const { Title, Paragraph } = Typography;

export function ParticipanteHome({ hidenMenu, ocultarData }) {

  const [fileData, setFileData] = useState({
    tree: [],
    params: {},
    stats: {},
    basePath: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getInformeParticipante();

        setFileData({
          basePath: data?.basePath ?? "",
          params: data?.params ?? {},
          stats: data?.stats ?? {},
          tree: Array.isArray(data?.tree) ? data.tree : [],
        });

      } catch (error) {
        console.error("❌ Error cargando datos:", error);

        setFileData({
          tree: [],
          params: {},
          stats: {},
          basePath: "",
        });
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {/* ENCABEZADO SUPERIOR */}
      <Card
        style={{
          padding: 10,
          borderRadius: 5,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          backgroundColor: "#042956",
          marginBottom: 20,
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={2} style={{ margin: 0, color: "#ffffff" }}>
              <FontAwesomeIcon
                onClick={hidenMenu}
                icon={ocultarData ? faEyeSlash : faEye}
                style={{ marginRight: 10, cursor: "pointer" }}
              />
              <FontAwesomeIcon icon={faFile} style={{ marginRight: 10 }} />
              Participantes
            </Title>
            <Paragraph style={{ margin: 0, color: "rgba(255,255,255,0.8)" }}>
              Administrar y editar información de archivos
            </Paragraph>
          </Col>
        </Row>
      </Card>
      <Row style={{ marginTop: "20px" }}>
        <Col xs={24}>
          <Tabs
            defaultActiveKey="table"
            centered
            size="large"
            tabBarStyle={{ fontWeight: "600" }}
            items={[
              {
                key: "table",
                label: (
                  <span>
                    <FontAwesomeIcon icon={faFolderOpen} style={{ marginRight: 8 }} />
                    Tabla de Archivos
                  </span>
                ),
                children: (
                  <div style={{ marginTop: 20 }}>
                    <FileManagementDashboard data={fileData} />
                  </div>
                ),
              },
              {
                key: "analytics",
                label: (
                  <span>
                    <FontAwesomeIcon icon={faChartColumn} style={{ marginRight: 8 }} />
                    Análisis y Gráficas
                  </span>
                ),
                children: (
                  <div style={{ marginTop: 20 }}>
                    <FileAnalyticsCharts data={fileData} />
                  </div>
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
}
